"use client";
import React from "react";
import { ArticlesAndInsights } from "@bfl-ui-toolkit/articles-and-insights";
import { IRelatedArticles } from "../../interfaces/IAMCContent.interface";
import useMediaQuery from "@repo/shared-ui/useMediaQuery";

interface AMCRelatedArticlesProps {
  relatedArticleData: IRelatedArticles;
}

export const AMCRelatedArticles: React.FC<AMCRelatedArticlesProps> = ({ relatedArticleData }) => {
  const {
    Articlestitle = "",
    slidesPerViewDesktop = 3.5,
    slidesPerViewMobile = 1.5,
    articleData = [],
  } = relatedArticleData ?? {};

  const articlesList =
    Object.values(articleData?.[0] ?? []).map((item) => ({
      date: item.date,
      imageUrl: item?.imageSrcUrl ?? "",
      link: item.pageurl,
      title: item.articledescription,
    })) ?? [];

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <div
      className="mb-3 md:px-5 md:py-2"
      data-cmp="AMCRelatedArticles"
      data-cmp-type="react"
      data-cmp-title={Articlestitle || "Related Articles"}
    >
      <ArticlesAndInsights
        articlesList={articlesList}
        readMoreCtaText="Read More"
        slidesPerView={(isMobile ? slidesPerViewMobile : slidesPerViewDesktop) as "auto"}
        spaceBetween={16}
        title={Articlestitle}
      />
    </div>
  );
};

export default AMCRelatedArticles;
